import { create } from 'zustand';

interface RequirementsModalStore {
  isOpen: boolean;
  index: number;
  openModal: (index: number) => void;
  closeModal: () => void;
}

export const useRequirementsModalStore = create<RequirementsModalStore>((set) => ({
  isOpen: false,
  index: 0,
  openModal: (index: number) => set({ isOpen: true, index }),
  closeModal: () => set({ isOpen: false })
}));
